import { render, staticRenderFns } from "./CallGroupDetail.vue?vue&type=template&id=18bec8da"
import script from "./CallGroupDetail.vue?vue&type=script&lang=js"
export * from "./CallGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports